export const User = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      d="M3 16.5C3 13.1863 5.68629 10.5 9 10.5C12.3137 10.5 15 13.1863 15 16.5H13.5C13.5 14.0147 11.4853 12 9 12C6.51472 12 4.5 14.0147 4.5 16.5H3ZM9 9.75C6.51375 9.75 4.5 7.73625 4.5 5.25C4.5 2.76375 6.51375 0.75 9 0.75C11.4862 0.75 13.5 2.76375 13.5 5.25C13.5 7.73625 11.4862 9.75 9 9.75ZM9 8.25C10.6575 8.25 12 6.9075 12 5.25C12 3.5925 10.6575 2.25 9 2.25C7.3425 2.25 6 3.5925 6 5.25C6 6.9075 7.3425 8.25 9 8.25Z"
    />
  </svg>
);
